import { Outlet } from "react-router-dom";
import { SectionSidebarNav, type SectionSidebarNavLinkItem } from "@/components/SectionSidebarNav";

const NAV: SectionSidebarNavLinkItem[] = [
  { key: "uebersicht", label: "Übersicht", href: "/veranstaltungen", end: true },
  {
    key: "messe",
    label: "Veranstaltungen Messe",
    href: "/veranstaltungen/messe",
    badgeKeys: ["veranstaltungen-ungelesen"],
  },
  { key: "meros", label: "Meros", href: "/veranstaltungen/meros" },
];

export function VeranstaltungenLayout() {
  return (
    <div className="eh-bestellwesen-page-shell">
      <SectionSidebarNav items={NAV} ariaLabel="Veranstaltungen" />
      <div className="eh-project-page-main">
        <Outlet />
      </div>
    </div>
  );
}
